var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenWalletDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2695,
    cy: 26.5,
    r: 25.5,
    stroke: "url(#paint0_linear_4471_32455)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4471_32455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5035 15.7605C23.7325 15.2922 24.2032 15 24.7164 15H29.8227C30.3358 15 30.8066 15.2922 31.0356 15.7605L31.341 16.375H35.4124C36.1631 16.375 36.7695 16.9895 36.7695 17.75C36.7695 18.5105 36.1631 19.125 35.4124 19.125H19.1267C18.376 19.125 17.7695 18.5105 17.7695 17.75C17.7695 16.9895 18.376 16.375 19.1267 16.375H23.1981L23.5035 15.7605ZM19.1267 20.5H35.4124V34.25C35.4124 35.7668 34.1952 37 32.6981 37H21.841C20.3439 37 19.1267 35.7668 19.1267 34.25V20.5ZM23.1981 23.25C22.8249 23.25 22.5195 23.5594 22.5195 23.9375V33.5625C22.5195 33.9406 22.8249 34.25 23.1981 34.25C23.5713 34.25 23.8767 33.9406 23.8767 33.5625V23.9375C23.8767 23.5594 23.5713 23.25 23.1981 23.25ZM27.2695 23.25C26.8963 23.25 26.591 23.5594 26.591 23.9375V33.5625C26.591 33.9406 26.8963 34.25 27.2695 34.25C27.6427 34.25 27.9481 33.9406 27.9481 33.5625V23.9375C27.9481 23.5594 27.6427 23.25 27.2695 23.25ZM31.341 23.25C30.9677 23.25 30.6624 23.5594 30.6624 23.9375V33.5625C30.6624 33.9406 30.9677 34.25 31.341 34.25C31.7142 34.25 32.0195 33.9406 32.0195 33.5625V23.9375C32.0195 23.5594 31.7142 23.25 31.341 23.25Z",
    fill: "url(#paint1_linear_4471_32455)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4471_32455",
    x1: 2.76953,
    y1: 28.1334,
    x2: 51.7695,
    y2: 28.1334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF96FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4471_32455",
    x1: 17.7695,
    y1: 26.7333,
    x2: 36.7695,
    y2: 26.7333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF96FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4471_32455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 22,
    fill: "white",
    transform: "translate(17.7695 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenWalletDelete);
export default __webpack_public_path__ + "static/media/token_wallet_delete.548077c6af09f83a7397b164bccb13e9.svg";
export { ForwardRef as ReactComponent };